import { AfterViewInit, Component, OnInit, Renderer2, OnDestroy, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { FirebaseService } from "../../providers/firebase.service";
import { ActivatedRoute, Router } from "@angular/router";
import { ComponentSettings } from "../../models/componentSettings";
import { FeatureItem } from "../../models/feature-item";
import { isNullOrUndefined, isUndefined } from "util";
import { Client } from "../../models/client";
import { MovingSuppliesItem } from "../../models/movingSuppliesItem";
import { HTMLRow } from "../../models/htmlRow";
import { ViewAllUnits } from "../../models/viewAllUnits";
import { MapMarker } from '../../models/MapMarker';
import { MapsService } from '../../providers/maps.service';
import { LocationInfo } from '../../models/locationInfo';
import { MdSlideToggleChange } from "@angular/material";
import 'rxjs/add/observable/merge';
import 'rxjs/add/operator/toArray';
import { Observable } from 'rxjs/Observable';
import { ScrollService } from "../../providers/scroll.service";
import { environment } from '../../../environments/environment';
import { svgIconOptions } from '../../models/svgIconOptions';
import { svgLinedIconOptions } from '../../models/svgLinedIconOptions';
import { HowToCard } from '../../models/howToCard';
import { svgColorLinedIconOptions } from '../../models/svgColoredLinedIconOptions';
import { DragulaService } from 'ng2-dragula';
import { Subscription } from 'rxjs';
import * as _ from 'lodash';

@Component({
  selector: 'app-component-settings',
  templateUrl: './component-data-settings.component.html',
  styleUrls: ['./component-data-settings.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ComponentDataSettingsComponent implements OnInit, AfterViewInit, OnDestroy {
  key: string;
  removeListener;
  componentSettings: ComponentSettings;

  movingSuppliesItem: MovingSuppliesItem;
  selectedMovingSuppliesItem: MovingSuppliesItem;
  newMovingSuppliesItem: boolean;
  displayMovingSuppliesItemDialog: boolean;

  newHTMLRow: boolean;
  htmlRow: HTMLRow;
  selectedHTMLRow: HTMLRow;
  _htmlRows: string[] = [];
  private _dragulaSub: Subscription
  get htmlRows() { return this._htmlRows };
  set htmlRows(value: string[]) {
    this._htmlRows = value || [];
  };

  feature: FeatureItem;
  selectedFeature: FeatureItem;
  newFeature: boolean;
  displayFeatureDialog: boolean;

  clientData: Client;
  options = {
    key: environment.froalaKey,
    placeholderText: 'Edit Your Content Here! Don\'t leave this blank or else nothing will show up on your website.',
    charCounterCount: true,
    toolbarButtons: ['undo', 'redo', '|', 'bold', 'italic', 'underline', '|', 'insertImage', 'strikeThrough', 'outdent', 'indent', 'clearFormatting', 'insertLink', 'emoticons', 'html'],
    toolbarButtonsXS: ['undo', 'redo', '-', 'bold', 'italic', 'underline'],
    htmlExecuteScripts: false,
    pasteDeniedAttrs: [],
    htmlAllowedAttrs: ['accept', 'accept-charset', 'accesskey', 'action', 'align', 'allowfullscreen', 'allowtransparency', 'alt', 'aria-.*', 'async', 'autocomplete', 'autofocus', 'autoplay', 'autosave', 'background', 'bgcolor', 'border', 'charset', 'cellpadding', 'cellspacing', 'checked', 'cite', 'class', 'color', 'cols', 'colspan', 'content', 'contenteditable', 'contextmenu', 'controls', 'coords', 'data', 'data-.*', 'datetime', 'default', 'defer', 'dir', 'dirname', 'disabled', 'download', 'draggable', 'dropzone', 'enctype', 'for', 'form', 'formaction', 'frameborder', 'headers', 'height', 'hidden', 'high', 'href', 'hreflang', 'http-equiv', 'icon', 'id', 'ismap', 'itemprop', 'keytype', 'kind', 'label', 'lang', 'language', 'list', 'loop', 'low', 'max', 'maxlength', 'media', 'method', 'min', 'mozallowfullscreen', 'multiple', 'muted', 'name', 'novalidate', 'open', 'optimum', 'pattern', 'ping', 'placeholder', 'playsinline', 'poster', 'preload', 'pubdate', 'radiogroup', 'readonly', 'rel', 'required', 'reversed', 'rows', 'rowspan', 'sandbox', 'scope', 'scoped', 'scrolling', 'seamless', 'selected', 'shape', 'size', 'sizes', 'span', 'src', 'srcdoc', 'srclang', 'srcset', 'start', 'step', 'summary', 'spellcheck', 'style', 'tabindex', 'target', 'title', 'type', 'translate', 'usemap', 'value', 'valign', 'webkitallowfullscreen', 'width', 'wrap', 'onclick'],
    htmlAllowedTags: ['a', 'abbr', 'address', 'area', 'article', 'aside', 'audio', 'b', 'base', 'bdi', 'bdo', 'blockquote', 'br', 'button', 'canvas', 'caption', 'cite', 'code', 'col', 'colgroup', 'datalist', 'dd', 'del', 'details', 'dfn', 'dialog', 'div', 'dl', 'dt', 'em', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'header', 'hgroup', 'hr', 'i', 'iframe', 'img', 'input', 'ins', 'kbd', 'keygen', 'label', 'legend', 'li', 'link', 'main', 'map', 'mark', 'menu', 'menuitem', 'meter', 'nav', 'noscript', 'object', 'ol', 'optgroup', 'option', 'output', 'p', 'param', 'pre', 'progress', 'queue', 'rp', 'rt', 'ruby', 's', 'samp', 'script', 'style', 'section', 'select', 'small', 'source', 'span', 'strike', 'strong', 'sub', 'summary', 'sup', 'table', 'tbody', 'td', 'textarea', 'tfoot', 'th', 'thead', 'time', 'tr', 'track', 'u', 'ul', 'var', 'video', 'wbr', 'script', 'style'],
  }
  options2 = {
    key: environment.froalaKey,
    placeholderText: 'This text will show up on the select insurance screen.',
    charCounterCount: true,
    toolbarButtons: ['undo', 'redo', '|', 'bold', 'italic', 'underline', 'fontSize', '|', 'insertImage', 'strikeThrough', 'outdent', 'indent', 'clearFormatting', 'insertLink', 'emoticons', 'html'],
    toolbarButtonsXS: ['undo', 'redo', '-', 'bold', 'italic', 'underline'],
    htmlExecuteScripts: false,
    pasteDeniedAttrs: [],
    htmlAllowedAttrs: ['accept', 'accept-charset', 'accesskey', 'action', 'align', 'allowfullscreen', 'allowtransparency', 'alt', 'aria-.*', 'async', 'autocomplete', 'autofocus', 'autoplay', 'autosave', 'background', 'bgcolor', 'border', 'charset', 'cellpadding', 'cellspacing', 'checked', 'cite', 'class', 'color', 'cols', 'colspan', 'content', 'contenteditable', 'contextmenu', 'controls', 'coords', 'data', 'data-.*', 'datetime', 'default', 'defer', 'dir', 'dirname', 'disabled', 'download', 'draggable', 'dropzone', 'enctype', 'for', 'form', 'formaction', 'frameborder', 'headers', 'height', 'hidden', 'high', 'href', 'hreflang', 'http-equiv', 'icon', 'id', 'ismap', 'itemprop', 'keytype', 'kind', 'label', 'lang', 'language', 'list', 'loop', 'low', 'max', 'maxlength', 'media', 'method', 'min', 'mozallowfullscreen', 'multiple', 'muted', 'name', 'novalidate', 'open', 'optimum', 'pattern', 'ping', 'placeholder', 'playsinline', 'poster', 'preload', 'pubdate', 'radiogroup', 'readonly', 'rel', 'required', 'reversed', 'rows', 'rowspan', 'sandbox', 'scope', 'scoped', 'scrolling', 'seamless', 'selected', 'shape', 'size', 'sizes', 'span', 'src', 'srcdoc', 'srclang', 'srcset', 'start', 'step', 'summary', 'spellcheck', 'style', 'tabindex', 'target', 'title', 'type', 'translate', 'usemap', 'value', 'valign', 'webkitallowfullscreen', 'width', 'wrap', 'onclick'],
    htmlAllowedTags: ['a', 'abbr', 'address', 'area', 'article', 'aside', 'audio', 'b', 'base', 'bdi', 'bdo', 'blockquote', 'br', 'button', 'canvas', 'caption', 'cite', 'code', 'col', 'colgroup', 'datalist', 'dd', 'del', 'details', 'dfn', 'dialog', 'div', 'dl', 'dt', 'em', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'header', 'hgroup', 'hr', 'i', 'iframe', 'img', 'input', 'ins', 'kbd', 'keygen', 'label', 'legend', 'li', 'link', 'main', 'map', 'mark', 'menu', 'menuitem', 'meter', 'nav', 'noscript', 'object', 'ol', 'optgroup', 'option', 'output', 'p', 'param', 'pre', 'progress', 'queue', 'rp', 'rt', 'ruby', 's', 'samp', 'script', 'style', 'section', 'select', 'small', 'source', 'span', 'strike', 'strong', 'sub', 'summary', 'sup', 'table', 'tbody', 'td', 'textarea', 'tfoot', 'th', 'thead', 'time', 'tr', 'track', 'u', 'ul', 'var', 'video', 'wbr', 'script', 'style'],
  }
  mapPlacement = [
    { label: 'Top', value: 'top' },
    { label: 'Bottom', value: 'bottom' },
    { label: 'None', value: 'none' }
  ];
  svgOptions = [
    { label: 'Filled with Circle', value: 'svgIconOptions' },
    { label: 'Lined', value: 'svgLinedIconOptions' },
    { label: 'Lined (Two Colors)', value: 'svgColorLinedIconOptions' },
  ];
  mapOptions;
  iconOptions;
  mapMarker: MapMarker;
  selectedMapMarker: MapMarker;
  newMapMarker: boolean;
  displayMapMarkerDialog: boolean;
  locations: LocationInfo[];
  displayGenerateMarkersDialog: boolean;
  isDestroyed = false;

  constructor(
    public afService: FirebaseService,
    private router: Router,
    private route: ActivatedRoute,
    private scroll: ScrollService,
    private mapsService: MapsService,
    private renderer: Renderer2,
    private cdRef: ChangeDetectorRef,
    public dragulaService: DragulaService
  ) { }

  ngOnInit() {
    if (!this._htmlRows) {
      this._htmlRows = [];
    }
    this._dragulaSub = this.dragulaService.dropModel.subscribe(domStuff => this.save());

    this.route.params.subscribe((params) => {
      this.key = params['key'];

      this.afService.getClientInfo(this.key).subscribe((clientData) => {
        this.clientData = clientData;

        this.afService.getLocations(this.clientData).subscribe((locations: LocationInfo[]) => {
          this.locations = locations
          this.mapOptions = [{}, ...this.locations.map(l => ({ label: l.name, value: l.$key }))]
        });

        this.afService.loadComponentSettings(this.key).subscribe((data) => {

          if (isUndefined(data.$value)) {
            let shouldSave = false;
            this.componentSettings = data;
            if (this.componentSettings.svgType == 'svgLinedIconOptions') {
              this.iconOptions = svgLinedIconOptions;
            }
            else if (this.componentSettings.svgType == 'svgColorLinedIconOptions') {
              this.iconOptions = svgColorLinedIconOptions;
            }
            else {
              this.iconOptions = svgIconOptions;
            }
            if (isNullOrUndefined(this.componentSettings.howToRow)) {
              this.componentSettings.howToRow = { title: '', blurb: '', cards: [] }
            }
            if (isNullOrUndefined(this.componentSettings.pictureCard)) {
              this.componentSettings.pictureCard = { title: '', buttonText: '', buttonUrl: '', cardItem: [] }
            }
            if (isNullOrUndefined(this.componentSettings.slideshowRow)) {
              this.componentSettings.slideshowRow = {
                titleText: '',
                sliderAutoPlay: true,
                showSliderArrows: false,
                articleText: '',
                sliderUrls: []
              }
              shouldSave = true;
            }
            else if (isNullOrUndefined(this.componentSettings.slideshowRow.sliderUrls)) {
              this.componentSettings.slideshowRow.sliderUrls = [];
            }

            if (this.clientData.separatorBarData && !this.componentSettings.separatorBar) {
              this.componentSettings.separatorBar = {
                title: '',
                text: ''
              }

              if (this.clientData.separatorBarData.title && !this.componentSettings.separatorBar.title) {
                this.componentSettings.separatorBar.title = this.clientData.separatorBarData.title;
                shouldSave = true;
              }
              if (this.clientData.separatorBarData.text && !this.componentSettings.separatorBar.text) {
                this.componentSettings.separatorBar.text = this.clientData.separatorBarData.text;
                shouldSave = true;
              }
            }

            if (isNullOrUndefined(this.componentSettings.viewAllUnits)) {
              this.componentSettings.viewAllUnits = new ViewAllUnits();
              shouldSave = true;
            }
            if (isNullOrUndefined(this.componentSettings.features)) {
              this.componentSettings.features = [];
            }
            else if (isNullOrUndefined(this.componentSettings.viewAllUnits.rentSummaryTitle)) {
              this.componentSettings.viewAllUnits.rentSummaryTitle = true;
              this.componentSettings.viewAllUnits.reserveSummaryTitle = true;
              shouldSave = true;
            }
            if (isNullOrUndefined(this.componentSettings.reserveSuccess)) {
              this.componentSettings.reserveSuccess = {
                success: 'Unit successfully reserved!',
                line1: `Thank you for choosing ${ this.clientData.name } for your storage needs! To complete the reservation please come into the office within 7 days of your reservation date.`,
                line2: 'If you have any questions, concerns, or need to make any changes, please don’t hesitate to contact us. We look forward to working with you!'
              };
              shouldSave = true;
            }
            if (isNullOrUndefined(this.componentSettings.rentSuccess)) {
              this.componentSettings.rentSuccess = {
                success: 'Unit successfully rented!',
                line1: `Thank you for choosing ${ this.clientData.name } for your storage needs! Please stop by the office during business hours to meet with one of our friendly on-site managers. They will confirm all of your details and show you around the facility. If you have any questions, concerns, or need to make any changes, please don’t hesitate to contact us.`,
                line2: 'You can easily see the status of your unit(s), make payments, and manage your account on our website with the account you created during the rental process.',
                line1Bold: false,
                line2Bold: false
              };
              shouldSave = true;
            }
            if (isNullOrUndefined(this.componentSettings.rentReserveUnit)) {
              this.componentSettings.rentReserveUnit = {
                officeHours: 'Mon-Fri: 10:00A-6:00P / Sat: 9:00A-4:00P',
                gateHours: '6:00A-10P Daily',
                showInsuranceBlurb: false,
                insuranceBlurb: null
              };
              shouldSave = true;
            }
            if (isNullOrUndefined(this.componentSettings.facilityInfoBanner)) {
              this.componentSettings.facilityInfoBanner = {};
            }

            if (isNullOrUndefined(this.componentSettings.locationsNearYou)) {
              this.componentSettings.locationsNearYou = {};
            }

            if (isNullOrUndefined(this.componentSettings.smallPrimaryIconBar.backText1)) {
              this.componentSettings.smallPrimaryIconBar.backText1 = "";
              this.componentSettings.smallPrimaryIconBar.backText2 = "";
              this.componentSettings.smallPrimaryIconBar.backText3 = "";
            }

            if (isNullOrUndefined(this.componentSettings.smallPrimaryIconBar.seoTitle1)) {
              this.componentSettings.smallPrimaryIconBar.seoTitle1 = "";
              this.componentSettings.smallPrimaryIconBar.seoTitle2 = "";
              this.componentSettings.smallPrimaryIconBar.seoTitle3 = "";
              this.componentSettings.smallPrimaryIconBar.alt1 = "";
              this.componentSettings.smallPrimaryIconBar.alt2 = "";
              this.componentSettings.smallPrimaryIconBar.alt3 = "";
            }

            if (isNullOrUndefined(this.componentSettings.viewAllUnits.filters)) {
              this.componentSettings.viewAllUnits.filters = {
                walkInCloset: 'Walk-in Closet',
                midSizeRoom: 'Mid-size Room',
                familyRoom: 'Family Room',
                threeBedrooms: '3 Bedrooms',
                fullHouse: 'Full House',
                largeHouse: 'Large House'
              };
              shouldSave = true;
            }

            if (isNullOrUndefined(this.componentSettings.viewAllUnits.show5x5)) {
              this.componentSettings.viewAllUnits.show5x5 = true;
              this.componentSettings.viewAllUnits.show5x10 = true;
              this.componentSettings.viewAllUnits.show10x10 = true;
              this.componentSettings.viewAllUnits.show10x15 = true;
              this.componentSettings.viewAllUnits.show10x20 = true;
              this.componentSettings.viewAllUnits.show10x25 = true;
              shouldSave = true;
            }

            if (isNullOrUndefined(this.componentSettings.viewAllUnits.holidays)) {
              this.componentSettings.viewAllUnits.holidays = {
                newYears: true,
                mlk: false,
                washingtonBirthday: false,
                armedForces: false,
                memorial: true,
                flag: false,
                independence: true,
                labor: true,
                columbus: false,
                veterans: false,
                thanksgiving: false,
                christmas: true,
                christmasEve: true,
                newYearsEve: true
              }
              shouldSave = true;
            }

            if (isNullOrUndefined(this.componentSettings.footer)) {
              this.componentSettings.footer = {};
            }

            if (isNullOrUndefined(this.componentSettings.smallFooterLinks)) {
              this.componentSettings.smallFooterLinks = [];
            }


            if (isNullOrUndefined(this.componentSettings.homePageBlogBanner)) {
              this.componentSettings.homePageBlogBanner = {};
            }

            if (isUndefined(this.componentSettings.htmlRows)) {
              this.componentSettings.htmlRows = [
                new HTMLRow()
              ];
              shouldSave = true;
            }

            if (isUndefined(this.componentSettings.movingSupplies.itemsOffered)) {
              this.componentSettings.movingSupplies.itemsOffered = [
                new MovingSuppliesItem('Packaging Tape'),
                new MovingSuppliesItem('Boxes'),
                new MovingSuppliesItem('Stretch Film'),
                new MovingSuppliesItem('Bubble Wrap'),
                new MovingSuppliesItem('Mattress Bags'),
                new MovingSuppliesItem('Moving Blanket'),
                new MovingSuppliesItem('Lights'),
                new MovingSuppliesItem('Rope')
              ];
              shouldSave = true;
            }

            if (isUndefined(this.componentSettings.maps)) {
              const tmpMarker: MapMarker = {
                title: 'Rocky Hill Storage',
                body: '1409 Wrights Ferry Rd.<br>\\nKnoxville, TN',
                customIconUrl: 'https://firebasestorage.googleapis.com/v0/b/storpug-604b6.appspot.com/o/map-icon.png?alt=media&token=9e773f5c-393d-4635-9ff6-2806b18d262f',
                latitude: 35.9016015,
                longitude: -84.0210016,
                useCustomInfoWindow: true,
                infoWindowMaxWidth: 400
              };

              this.componentSettings.maps = {
                placement: 'top',
                markers: [tmpMarker],
                latitude: 35.9016015,
                longitude: -84.0210016,
                blurb: '',
                zoom: 16,
                styles: []
              }

              shouldSave = true;
            }
            if (isUndefined(this.componentSettings.homepageLinksCardLinks)) {
              this.componentSettings.homepageLinksCardLinks = [
                {
                  iconClass: 'attach_money',
                  isExternal: false,
                  title: 'Rent Now',
                  subtitle: 'Rent your self storage unit right on our website 24/7',
                  link: '/units'
                },
                {
                  iconClass: 'weekend',
                  isExternal: false,
                  title: 'Size Guide',
                  subtitle: 'Need help choosing the right storage unit? Look at our size guide for a reference of what fits',
                  link: '/size-guide'
                },
                {
                  iconClass: 'account_circle',
                  isExternal: false,
                  title: 'My Account',
                  subtitle: 'Access your online account to conveniently pay, setup autopay, schedule a move out, and more',
                  link: '/customer-portal/login'
                },
                {
                  iconClass: 'help',
                  isExternal: false,
                  title: 'Frequently Asked Questions',
                  subtitle: 'During our years of storage experience, we have heard it all. Click here for a collection of common questions',
                  link: '/faq'
                },
                {
                  iconClass: 'insert_emoticon',
                  isExternal: false,
                  title: 'About Us',
                  subtitle: 'Click here to read more about our self storage story',
                  link: '/about'
                },
                {
                  iconClass: 'phone_in_talk',
                  isExternal: false,
                  title: 'Contact Us',
                  subtitle: 'Questions, comments, or concerns? We always appreciate your feedback',
                  link: '/contact'
                }
              ];
              shouldSave = true;
            }

            if (shouldSave) {
              this.saveComponentSettings();
            }

            try {
              if (!this.isDestroyed) {
                this.cdRef.detectChanges();
              }
            }
            catch (error) {

            }
          }
          else {
            this.componentSettings = new ComponentSettings(this.clientData.name);
            if (!this.isDestroyed) {
              this.cdRef.detectChanges();
            }
            this.afService.saveComponentSettings(this.clientData, this.componentSettings).then(() => {
              this.afService.openSnackBar('Component Settings Created');
            }).catch(e => {
              this.afService.openSnackBar(e.message);
            });
          }
        });
      })
    });


    this.removeListener = this.renderer.listen('window', 'keydown', (event: KeyboardEvent) => {
      if (event.ctrlKey && event.keyCode === 83) {
        for (let tmp of this.componentSettings.features) {
          delete tmp._$visited;
        }

        for (let tmp of this.componentSettings.movingSupplies.itemsOffered) {
          delete tmp._$visited;
        }

        for (let tmp of this.componentSettings.maps.markers) {
          delete tmp._$visited;
        }

        this.afService.saveComponentSettings(this.clientData, this.componentSettings).then((data) => {
          this.afService.openSnackBar('Component Settings Updated.');
          this.afService.updateSettingsOnServer(this.clientData);
        }).catch(e => {
          this.afService.openSnackBar(e.message);
        });
      }
    });
  }

  ngAfterViewInit() {
    this.scroll.scrollToTop();
  }

  ngOnDestroy() {
    this.isDestroyed = true;
    this.removeListener();
    try {
      if (this.dragulaService) {
        this.dragulaService.destroy('html-rows-bag');
      }
      if (this._dragulaSub && !this._dragulaSub.closed) {
        this._dragulaSub.unsubscribe();
      }
    }
    catch (err) {
      console.warn('ngOnDestroy error caught:', err);
    }
  }

  save() {
    this.htmlRows = this._htmlRows;
    this.saveComponentSettings();
  }

  showFeatureDialogToAdd() {
    this.newFeature = true;
    this.feature = new FeatureItem();
    this.displayFeatureDialog = true;
  }

  onFeatureRowSelect(event) {
    this.newFeature = false;
    this.feature = event.data;
    this.displayFeatureDialog = true;
  }

  saveFeature(e = null) {
    if (this.newFeature == true) {
      this.componentSettings.features.push(this.feature);
    }
    else {
      this.selectedFeature = e.data;
      this.componentSettings.features[this.findFeatureIndex()] = e.data;
    }

    console.log(e)
    this.feature = null;

    this.displayFeatureDialog = false;
    this.saveComponentSettings();
  }

  deleteFeature(featureIndex) {
    let index = _.findIndex(this.componentSettings.features, { 'iconUrl': featureIndex.iconUrl, 'name': featureIndex.name });
    if (confirm('Are you sure?')) {
      this.componentSettings.features = this.componentSettings.features.filter((val, i) => i != index);
      this.selectedFeature = null;
      this.displayFeatureDialog = false;
      this.saveComponentSettings();
    }
  }

  findFeatureIndex(): number {
    return this.componentSettings.features.indexOf(this.selectedFeature);
  }

  saveMdToggle(event: MdSlideToggleChange, key) {
    this.componentSettings[key] = event.checked;
    this.saveComponentSettings();
  }

  saveSetHeightToScreen(event: MdSlideToggleChange) {
    this.componentSettings.simpleSliderBanner.setHeightToScreen = event.checked;
    this.saveComponentSettings();
  }

  showHTMLRowsToAdd() {
    this.newHTMLRow = true;
    this.componentSettings.htmlRows.push(new HTMLRow());
  }

  deleteHTMLRow(index) {
    const result = confirm('Are you sure?');
    if (result) {
      this.componentSettings.htmlRows.splice(index, 1);
      this.saveComponentSettings();
    }
  }

  saveHTMLRow(e = null) {
    if (this.newHTMLRow == true) {
      if (isUndefined(this.componentSettings.htmlRows))
        this.componentSettings.htmlRows = new Array<HTMLRow>();

      this.componentSettings.htmlRows.push(this.htmlRow);
    }
    else if (isNullOrUndefined(e)) {
      this.componentSettings.htmlRows[this.findHTMLRowIndex()] = this.htmlRow;
    }
    else {
      this.selectedHTMLRow = e.data;
      this.componentSettings.htmlRows[this.findHTMLRowIndex()] = e.data
    }
    this.htmlRow = null;
    this.saveComponentSettings();
  }

  findHTMLRowIndex(): number {
    return this.componentSettings.htmlRows.indexOf(this.selectedHTMLRow);
  }

  showMovingSuppliesItemToAdd() {
    this.newMovingSuppliesItem = true;
    this.movingSuppliesItem = new MovingSuppliesItem();
    this.displayMovingSuppliesItemDialog = true;
  }

  onMovingSuppliesItemRowSelect(event) {
    this.newMovingSuppliesItem = false;
    this.movingSuppliesItem = event.data;
    this.displayMovingSuppliesItemDialog = true;
  }

  saveMovingSuppliesItem(e = null) {
    if (this.newMovingSuppliesItem == true) {
      if (isUndefined(this.componentSettings.movingSupplies.itemsOffered))
        this.componentSettings.movingSupplies.itemsOffered = new Array<MovingSuppliesItem>();

      this.componentSettings.movingSupplies.itemsOffered.push(this.movingSuppliesItem);
    }
    else if (isNullOrUndefined(e)) {
      this.componentSettings.movingSupplies.itemsOffered[this.findMovingSuppliesItemIndex()] = this.movingSuppliesItem;
    }
    else {
      this.selectedMovingSuppliesItem = e.data;
      this.componentSettings.movingSupplies.itemsOffered[this.findMovingSuppliesItemIndex()] = e.data
    }

    this.movingSuppliesItem = null;
    this.displayMovingSuppliesItemDialog = false;
    this.saveComponentSettings();
  }

  deleteMovingSuppliesItem(movingIndex) {
    let index = -1; // -1 if not found
    for (var i = 0; i < this.componentSettings.movingSupplies.itemsOffered.length; i++) {
      var element = this.componentSettings.movingSupplies.itemsOffered[i];
      if (element.label === movingIndex) {
        index = i;
        break;
      }
    }
    this.componentSettings.movingSupplies.itemsOffered = this.componentSettings.movingSupplies.itemsOffered.filter((val, i) => i != index);
    this.selectedMovingSuppliesItem = null;
    this.displayMovingSuppliesItemDialog = false;
    this.saveComponentSettings();
  }

  findMovingSuppliesItemIndex(): number {
    return this.componentSettings.movingSupplies.itemsOffered.indexOf(this.selectedMovingSuppliesItem);
  }

  showMapMarkerToAdd() {
    this.newMapMarker = true;
    this.mapMarker = new MapMarker();
    this.displayMapMarkerDialog = true;
  }

  onMapMarkerRowSelect(event) {
    this.newMapMarker = false;
    this.mapMarker = event.data;
    this.displayMapMarkerDialog = true;
  }

  saveMapMarker() {
    if (this.newMapMarker == true) {
      if (isUndefined(this.componentSettings.maps.markers))
        this.componentSettings.maps.markers = new Array<MapMarker>();

      this.componentSettings.maps.markers.push(this.mapMarker);
    }
    else {
      this.componentSettings.maps.markers[this.findMapMarkerIndex()] = this.mapMarker;
    }

    this.mapMarker = null;
    this.displayMapMarkerDialog = false;
    this.saveComponentSettings();
  }

  deleteMapMarker() {
    let index = this.findMapMarkerIndex();
    this.componentSettings.maps.markers = this.componentSettings.maps.markers.filter((val, i) => i != index);
    this.selectedMapMarker = null;
    this.displayMapMarkerDialog = false;
    this.saveComponentSettings();
  }

  findMapMarkerIndex(): number {
    return this.componentSettings.maps.markers.indexOf(this.selectedMapMarker);
  }

  generateMapMarkers(iconUrl?: string, CTAText?: string) {
    this.componentSettings.maps.markers = [];
    let observables: Observable<any>[] = [];
    for (let location of this.locations)
      observables.push(this.mapsService.getLatLong(location));

    console.log(this.locations)
    Observable.merge(...observables)
      .toArray()
      .subscribe((array: [any, LocationInfo][]) => {
        console.log(array)
        for (let [mapsResponse, location] of array) {
          if (mapsResponse) {
            let tmpMarker = new MapMarker();
            tmpMarker.title = location.name;
            tmpMarker.locationKey = location.$key;
            tmpMarker.customIconUrl = iconUrl;
            tmpMarker.useCustomInfoWindow = true;
            tmpMarker.infoWindowMaxWidth = 400;
            tmpMarker.latitude = mapsResponse.results[0].geometry.location.lat;
            tmpMarker.longitude = mapsResponse.results[0].geometry.location.lng;
            tmpMarker.body = `${ location.address }<br>
${ location.address2 }<br><br>
${ CTAText || 'Call us today!' }<br>
<a href='tel:${ location.phone }'>${ location.phone }</a><br><br>
<a class="pug-btn pug-btn-primary" href='https://www.google.com/maps?daddr=${ mapsResponse.results[0].formatted_address }' target='_blank'>Get Directions</a>`;

            this.componentSettings.maps.markers.push(tmpMarker);
          }
        }
        this.displayGenerateMarkersDialog = false;
        this.saveComponentSettings();
      });
  }

  async prefillMapMarker(event) {
    console.log("🚀 ~ file: component-data-settings.component.ts ~ line 676 ~ ComponentDataSettingsComponent ~ prefillMapMarker ~ event", event)
    if (isNullOrUndefined(event.value)) {
      this.mapMarker = new MapMarker();
      this.cdRef.detectChanges();
    }
    else {
      const selectedLocation = this.locations.find(l => l.$key === event.value)
      const sub = this.mapsService.getLatLong(selectedLocation)
        .subscribe(([mapsResponse, location]) => {
          sub.unsubscribe();
          if (mapsResponse) {
            this.mapMarker.title = selectedLocation.name;
            this.mapMarker.locationKey = selectedLocation.$key;
            this.mapMarker.useCustomInfoWindow = true;
            this.mapMarker.infoWindowMaxWidth = 400;
            this.mapMarker.latitude = mapsResponse.results[0].geometry.location.lat;
            this.mapMarker.longitude = mapsResponse.results[0].geometry.location.lng;
            this.mapMarker.body = `${ selectedLocation.address }<br>
${ selectedLocation.address2 }<br><br>
Call us today!<br>
<a href='tel:${ selectedLocation.phone }'>${ selectedLocation.phone }</a><br><br>
<a class="pug-btn pug-btn-primary" href='https://www.google.com/maps?daddr=${ mapsResponse.results[0].formatted_address }' target='_blank'>Get Directions</a>`;

            this.cdRef.detectChanges();
          }
        })
    }

  }

  saveComponentSettings() {
    if (this.componentSettings.features) {
      for (let tmp of this.componentSettings.features) {
        delete tmp._$visited;
      }
    }

    if (this.componentSettings.movingSupplies) {
      for (let tmp of this.componentSettings.movingSupplies.itemsOffered) {
        delete tmp._$visited;
      }
    }

    if (this.componentSettings.maps && this.componentSettings.maps.markers) {
      for (let tmp of this.componentSettings.maps.markers) {
        delete tmp._$visited;
      }
    }

    this.afService.saveComponentSettings(this.clientData, this.componentSettings).then((data) => {
      this.afService.openSnackBar('Component Settings Updated.');
    }).catch(e => {
      this.afService.openSnackBar(e.message);
    })
  }

  goBack() {
    this.router.navigate(['../../'], { relativeTo: this.route });
  }
}



// WEBPACK FOOTER //
// ./src/ng2/app/admin-portal/component-data-settings/component-data-settings.component.ts